import { render, staticRenderFns } from "./HomeType4Content.vue?vue&type=template&id=16707962&scoped=true"
import script from "./HomeType4Content.vue?vue&type=script&lang=js"
export * from "./HomeType4Content.vue?vue&type=script&lang=js"
import style0 from "./HomeType4Content.vue?vue&type=style&index=0&id=16707962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16707962",
  null
  
)

export default component.exports